// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/bid_limit_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { BidSegment } from "../../bfftypes/v1/bid_segment_pb";
import { file_bfftypes_v1_bid_segment } from "../../bfftypes/v1/bid_segment_pb";
import type { BidLimitCell, BidLimitSegmentMeta, BidTag, BidTagVariant, BlockMandatoryPolicy, DefaultWithdrawOffset, DefaultWithdrawOffsetSetting, FeeAutoConsiderPolicy, MarketOrderPolicyEntry } from "./bid_limit_model_pb";
import { file_bffuser_v1_bid_limit_model } from "./bid_limit_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/bid_limit_service.proto.
 */
export const file_bffuser_v1_bid_limit_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bfftypes_v1_bid_segment, file_bffuser_v1_bid_limit_model, file_buf_validate_validate, file_google_protobuf_timestamp]);

/**
 * @generated from message bffuser.v1.GetBidLimitMatrixScreenRequest
 */
export type GetBidLimitMatrixScreenRequest = Message<"bffuser.v1.GetBidLimitMatrixScreenRequest"> & {
};

/**
 * Describes the message bffuser.v1.GetBidLimitMatrixScreenRequest.
 * Use `create(GetBidLimitMatrixScreenRequestSchema)` to create a new message.
 */
export const GetBidLimitMatrixScreenRequestSchema: GenMessage<GetBidLimitMatrixScreenRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_service, 0);

/**
 * @generated from message bffuser.v1.GetBidLimitMatrixScreenResponse
 */
export type GetBidLimitMatrixScreenResponse = Message<"bffuser.v1.GetBidLimitMatrixScreenResponse"> & {
  /**
   * Decided cells for all three segments. Each cell carries its bid_segment.
   *
   * @generated from field: repeated bffuser.v1.BidLimitCell cells = 1;
   */
  cells: BidLimitCell[];

  /**
   * Optimistic-lock baselines for only segments whose meta rows exist.
   *
   * @generated from field: repeated bffuser.v1.BidLimitSegmentMeta segment_metas = 2;
   */
  segmentMetas: BidLimitSegmentMeta[];

  /**
   * Market-order policies for SPOT_NORMAL and INTRADAY.
   *
   * @generated from field: repeated bffuser.v1.MarketOrderPolicyEntry market_order_policy_entries = 3;
   */
  marketOrderPolicyEntries: MarketOrderPolicyEntry[];

  /**
   * Organization-wide SPOT_BLOCK toggle. Unset when its row does not exist.
   *
   * @generated from field: optional bffuser.v1.BlockMandatoryPolicy block_mandatory_policy = 4;
   */
  blockMandatoryPolicy?: BlockMandatoryPolicy;

  /**
   * Fee-auto-consider policies for SPOT_NORMAL and INTRADAY.
   *
   * @generated from field: repeated bffuser.v1.FeeAutoConsiderPolicy fee_auto_consider_policies = 6;
   */
  feeAutoConsiderPolicies: FeeAutoConsiderPolicy[];

  /**
   * Organization-wide INTRADAY default withdraw offset. Unset when its
   * row does not exist.
   *
   * @generated from field: optional bffuser.v1.DefaultWithdrawOffsetSetting default_withdraw_offset_setting = 5;
   */
  defaultWithdrawOffsetSetting?: DefaultWithdrawOffsetSetting;
};

/**
 * Describes the message bffuser.v1.GetBidLimitMatrixScreenResponse.
 * Use `create(GetBidLimitMatrixScreenResponseSchema)` to create a new message.
 */
export const GetBidLimitMatrixScreenResponseSchema: GenMessage<GetBidLimitMatrixScreenResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_service, 1);

/**
 * GetBidLimitMatrixRequest specifies which tab (= bid_segment) to fetch.
 *
 * @generated from message bffuser.v1.GetBidLimitMatrixRequest
 */
export type GetBidLimitMatrixRequest = Message<"bffuser.v1.GetBidLimitMatrixRequest"> & {
  /**
   * @generated from field: bfftypes.v1.BidSegment bid_segment = 1;
   */
  bidSegment: BidSegment;
};

/**
 * Describes the message bffuser.v1.GetBidLimitMatrixRequest.
 * Use `create(GetBidLimitMatrixRequestSchema)` to create a new message.
 */
export const GetBidLimitMatrixRequestSchema: GenMessage<GetBidLimitMatrixRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_service, 2);

/**
 * @generated from message bffuser.v1.GetBidLimitMatrixResponse
 */
export type GetBidLimitMatrixResponse = Message<"bffuser.v1.GetBidLimitMatrixResponse"> & {
  /**
   * Decided cells only (= row absent in DB → entry absent here).
   *
   * @generated from field: repeated bffuser.v1.BidLimitCell cells = 1;
   */
  cells: BidLimitCell[];

  /**
   * Optimistic-lock baseline. Absent for segments whose meta row has not
   * yet been created.
   *
   * @generated from field: bffuser.v1.BidLimitSegmentMeta segment_meta = 2;
   */
  segmentMeta?: BidLimitSegmentMeta;

  /**
   * SPOT_NORMAL / INTRADAY のみ populated。 SPOT_BLOCK では empty。
   *
   * @generated from field: repeated bffuser.v1.MarketOrderPolicyEntry market_order_policy_entries = 3;
   */
  marketOrderPolicyEntries: MarketOrderPolicyEntry[];

  /**
   * SPOT_BLOCK のみ set。 SPOT_NORMAL / INTRADAY では unset。
   *
   * @generated from field: optional bffuser.v1.BlockMandatoryPolicy block_mandatory_policy = 4;
   */
  blockMandatoryPolicy?: BlockMandatoryPolicy;

  /**
   * SPOT_NORMAL / INTRADAY のみ set。 SPOT_BLOCK では unset。
   *
   * @generated from field: optional bffuser.v1.FeeAutoConsiderPolicy fee_auto_consider_policy = 6;
   */
  feeAutoConsiderPolicy?: FeeAutoConsiderPolicy;

  /**
   * INTRADAY のみ set。 SPOT_NORMAL / SPOT_BLOCK では unset。 ensure_exists
   * default (row 不在) は IMMEDIATE。
   *
   * @generated from field: optional bffuser.v1.DefaultWithdrawOffsetSetting default_withdraw_offset_setting = 5;
   */
  defaultWithdrawOffsetSetting?: DefaultWithdrawOffsetSetting;
};

/**
 * Describes the message bffuser.v1.GetBidLimitMatrixResponse.
 * Use `create(GetBidLimitMatrixResponseSchema)` to create a new message.
 */
export const GetBidLimitMatrixResponseSchema: GenMessage<GetBidLimitMatrixResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_service, 3);

/**
 * UpdateBidLimitMatrixRequest carries the segment and cells to replace.
 * updated_by is resolved from eauth by the BFF handler.
 *
 * @generated from message bffuser.v1.UpdateBidLimitMatrixRequest
 */
export type UpdateBidLimitMatrixRequest = Message<"bffuser.v1.UpdateBidLimitMatrixRequest"> & {
  /**
   * @generated from field: bfftypes.v1.BidSegment bid_segment = 1;
   */
  bidSegment: BidSegment;

  /**
   * All decided cells for the segment after the edit.
   *
   * @generated from field: repeated bffuser.v1.BidLimitCell cells = 2;
   */
  cells: BidLimitCell[];

  /**
   * Optimistic-lock baseline. Absent when the segment_meta row does not
   * exist yet (= first save creates the row).
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 3;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.UpdateBidLimitMatrixRequest.
 * Use `create(UpdateBidLimitMatrixRequestSchema)` to create a new message.
 */
export const UpdateBidLimitMatrixRequestSchema: GenMessage<UpdateBidLimitMatrixRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_service, 4);

/**
 * @generated from message bffuser.v1.UpdateBidLimitMatrixResponse
 */
export type UpdateBidLimitMatrixResponse = Message<"bffuser.v1.UpdateBidLimitMatrixResponse"> & {
  /**
   * The new segment_meta after commit.
   *
   * @generated from field: bffuser.v1.BidLimitSegmentMeta segment_meta = 1;
   */
  segmentMeta?: BidLimitSegmentMeta;
};

/**
 * Describes the message bffuser.v1.UpdateBidLimitMatrixResponse.
 * Use `create(UpdateBidLimitMatrixResponseSchema)` to create a new message.
 */
export const UpdateBidLimitMatrixResponseSchema: GenMessage<UpdateBidLimitMatrixResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_service, 5);

/**
 * UpdateMarketOrderPolicyRequest carries the segment/area and the new
 * allowed flag. organization_id and updated_by are resolved from eauth.
 *
 * @generated from message bffuser.v1.UpdateMarketOrderPolicyRequest
 */
export type UpdateMarketOrderPolicyRequest = Message<"bffuser.v1.UpdateMarketOrderPolicyRequest"> & {
  /**
   * @generated from field: bfftypes.v1.BidSegment bid_segment = 2;
   */
  bidSegment: BidSegment;

  /**
   * 1-9 (沖縄除外、 see BidLimitCell.area_code).
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bool allowed = 4;
   */
  allowed: boolean;

  /**
   * Optimistic-lock baseline. Absent when the policy row does not exist
   * yet (= first toggle creates the row).
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 5;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.UpdateMarketOrderPolicyRequest.
 * Use `create(UpdateMarketOrderPolicyRequestSchema)` to create a new message.
 */
export const UpdateMarketOrderPolicyRequestSchema: GenMessage<UpdateMarketOrderPolicyRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_service, 6);

/**
 * @generated from message bffuser.v1.UpdateMarketOrderPolicyResponse
 */
export type UpdateMarketOrderPolicyResponse = Message<"bffuser.v1.UpdateMarketOrderPolicyResponse"> & {
  /**
   * The updated policy entry.
   *
   * @generated from field: bffuser.v1.MarketOrderPolicyEntry entry = 1;
   */
  entry?: MarketOrderPolicyEntry;
};

/**
 * Describes the message bffuser.v1.UpdateMarketOrderPolicyResponse.
 * Use `create(UpdateMarketOrderPolicyResponseSchema)` to create a new message.
 */
export const UpdateMarketOrderPolicyResponseSchema: GenMessage<UpdateMarketOrderPolicyResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_service, 7);

/**
 * UpdateBlockMandatoryPolicyRequest carries the enabled flag.
 * organization_id and updated_by are resolved from eauth.
 *
 * @generated from message bffuser.v1.UpdateBlockMandatoryPolicyRequest
 */
export type UpdateBlockMandatoryPolicyRequest = Message<"bffuser.v1.UpdateBlockMandatoryPolicyRequest"> & {
  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;

  /**
   * Optimistic-lock baseline. Absent when the policy row does not exist
   * yet (= first toggle creates the row).
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 3;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.UpdateBlockMandatoryPolicyRequest.
 * Use `create(UpdateBlockMandatoryPolicyRequestSchema)` to create a new message.
 */
export const UpdateBlockMandatoryPolicyRequestSchema: GenMessage<UpdateBlockMandatoryPolicyRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_service, 8);

/**
 * @generated from message bffuser.v1.UpdateBlockMandatoryPolicyResponse
 */
export type UpdateBlockMandatoryPolicyResponse = Message<"bffuser.v1.UpdateBlockMandatoryPolicyResponse"> & {
  /**
   * @generated from field: bffuser.v1.BlockMandatoryPolicy policy = 1;
   */
  policy?: BlockMandatoryPolicy;
};

/**
 * Describes the message bffuser.v1.UpdateBlockMandatoryPolicyResponse.
 * Use `create(UpdateBlockMandatoryPolicyResponseSchema)` to create a new message.
 */
export const UpdateBlockMandatoryPolicyResponseSchema: GenMessage<UpdateBlockMandatoryPolicyResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_service, 9);

/**
 * UpdateFeeAutoConsiderPolicyRequest carries the segment and the new
 * enabled flag. organization_id and updated_by are resolved from eauth.
 *
 * @generated from message bffuser.v1.UpdateFeeAutoConsiderPolicyRequest
 */
export type UpdateFeeAutoConsiderPolicyRequest = Message<"bffuser.v1.UpdateFeeAutoConsiderPolicyRequest"> & {
  /**
   * @generated from field: bfftypes.v1.BidSegment bid_segment = 2;
   */
  bidSegment: BidSegment;

  /**
   * @generated from field: bool enabled = 3;
   */
  enabled: boolean;

  /**
   * Optimistic-lock baseline. Absent when the policy row does not exist
   * yet (= first toggle creates the row).
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 4;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.UpdateFeeAutoConsiderPolicyRequest.
 * Use `create(UpdateFeeAutoConsiderPolicyRequestSchema)` to create a new message.
 */
export const UpdateFeeAutoConsiderPolicyRequestSchema: GenMessage<UpdateFeeAutoConsiderPolicyRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_service, 10);

/**
 * @generated from message bffuser.v1.UpdateFeeAutoConsiderPolicyResponse
 */
export type UpdateFeeAutoConsiderPolicyResponse = Message<"bffuser.v1.UpdateFeeAutoConsiderPolicyResponse"> & {
  /**
   * The updated policy.
   *
   * @generated from field: bffuser.v1.FeeAutoConsiderPolicy policy = 1;
   */
  policy?: FeeAutoConsiderPolicy;
};

/**
 * Describes the message bffuser.v1.UpdateFeeAutoConsiderPolicyResponse.
 * Use `create(UpdateFeeAutoConsiderPolicyResponseSchema)` to create a new message.
 */
export const UpdateFeeAutoConsiderPolicyResponseSchema: GenMessage<UpdateFeeAutoConsiderPolicyResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_service, 11);

/**
 * UpdateDefaultWithdrawOffsetRequest carries the new offset value.
 * organization_id and updated_by are resolved from eauth.
 *
 * @generated from message bffuser.v1.UpdateDefaultWithdrawOffsetRequest
 */
export type UpdateDefaultWithdrawOffsetRequest = Message<"bffuser.v1.UpdateDefaultWithdrawOffsetRequest"> & {
  /**
   * @generated from field: bffuser.v1.DefaultWithdrawOffset value = 2;
   */
  value: DefaultWithdrawOffset;

  /**
   * Optimistic-lock baseline. Absent when the policy row does not exist
   * yet (= first save creates the row).
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 3;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.UpdateDefaultWithdrawOffsetRequest.
 * Use `create(UpdateDefaultWithdrawOffsetRequestSchema)` to create a new message.
 */
export const UpdateDefaultWithdrawOffsetRequestSchema: GenMessage<UpdateDefaultWithdrawOffsetRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_service, 12);

/**
 * @generated from message bffuser.v1.UpdateDefaultWithdrawOffsetResponse
 */
export type UpdateDefaultWithdrawOffsetResponse = Message<"bffuser.v1.UpdateDefaultWithdrawOffsetResponse"> & {
  /**
   * @generated from field: bffuser.v1.DefaultWithdrawOffsetSetting setting = 1;
   */
  setting?: DefaultWithdrawOffsetSetting;
};

/**
 * Describes the message bffuser.v1.UpdateDefaultWithdrawOffsetResponse.
 * Use `create(UpdateDefaultWithdrawOffsetResponseSchema)` to create a new message.
 */
export const UpdateDefaultWithdrawOffsetResponseSchema: GenMessage<UpdateDefaultWithdrawOffsetResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_service, 13);

/**
 * ListBidTagsRequest carries no fields.
 *
 * @generated from message bffuser.v1.ListBidTagsRequest
 */
export type ListBidTagsRequest = Message<"bffuser.v1.ListBidTagsRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListBidTagsRequest.
 * Use `create(ListBidTagsRequestSchema)` to create a new message.
 */
export const ListBidTagsRequestSchema: GenMessage<ListBidTagsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_service, 14);

/**
 * @generated from message bffuser.v1.ListBidTagsResponse
 */
export type ListBidTagsResponse = Message<"bffuser.v1.ListBidTagsResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.BidTag tags = 1;
   */
  tags: BidTag[];
};

/**
 * Describes the message bffuser.v1.ListBidTagsResponse.
 * Use `create(ListBidTagsResponseSchema)` to create a new message.
 */
export const ListBidTagsResponseSchema: GenMessage<ListBidTagsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_service, 15);

/**
 * CreateBidTagRequest carries the tag fields.
 * organization_id and created_by are resolved from eauth.
 *
 * @generated from message bffuser.v1.CreateBidTagRequest
 */
export type CreateBidTagRequest = Message<"bffuser.v1.CreateBidTagRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: bffuser.v1.BidTagVariant variant = 2;
   */
  variant: BidTagVariant;

  /**
   * @generated from field: int32 sort_order = 3;
   */
  sortOrder: number;
};

/**
 * Describes the message bffuser.v1.CreateBidTagRequest.
 * Use `create(CreateBidTagRequestSchema)` to create a new message.
 */
export const CreateBidTagRequestSchema: GenMessage<CreateBidTagRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_service, 16);

/**
 * @generated from message bffuser.v1.CreateBidTagResponse
 */
export type CreateBidTagResponse = Message<"bffuser.v1.CreateBidTagResponse"> & {
  /**
   * @generated from field: bffuser.v1.BidTag tag = 1;
   */
  tag?: BidTag;
};

/**
 * Describes the message bffuser.v1.CreateBidTagResponse.
 * Use `create(CreateBidTagResponseSchema)` to create a new message.
 */
export const CreateBidTagResponseSchema: GenMessage<CreateBidTagResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_service, 17);

/**
 * UpdateBidTagRequest carries the tag id, new fields, and the optimistic-
 * lock baseline. organization_id and updated_by are resolved from eauth.
 *
 * @generated from message bffuser.v1.UpdateBidTagRequest
 */
export type UpdateBidTagRequest = Message<"bffuser.v1.UpdateBidTagRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: bffuser.v1.BidTagVariant variant = 3;
   */
  variant: BidTagVariant;

  /**
   * @generated from field: int32 sort_order = 4;
   */
  sortOrder: number;

  /**
   * Optimistic-lock baseline.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 5;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.UpdateBidTagRequest.
 * Use `create(UpdateBidTagRequestSchema)` to create a new message.
 */
export const UpdateBidTagRequestSchema: GenMessage<UpdateBidTagRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_service, 18);

/**
 * @generated from message bffuser.v1.UpdateBidTagResponse
 */
export type UpdateBidTagResponse = Message<"bffuser.v1.UpdateBidTagResponse"> & {
  /**
   * @generated from field: bffuser.v1.BidTag tag = 1;
   */
  tag?: BidTag;
};

/**
 * Describes the message bffuser.v1.UpdateBidTagResponse.
 * Use `create(UpdateBidTagResponseSchema)` to create a new message.
 */
export const UpdateBidTagResponseSchema: GenMessage<UpdateBidTagResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_service, 19);

/**
 * DeleteBidTagRequest carries the tag id and the optimistic-lock baseline.
 * organization_id is resolved from eauth.
 *
 * @generated from message bffuser.v1.DeleteBidTagRequest
 */
export type DeleteBidTagRequest = Message<"bffuser.v1.DeleteBidTagRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Optimistic-lock baseline.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.DeleteBidTagRequest.
 * Use `create(DeleteBidTagRequestSchema)` to create a new message.
 */
export const DeleteBidTagRequestSchema: GenMessage<DeleteBidTagRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_service, 20);

/**
 * DeleteBidTagResponse is intentionally empty (AIP-135).
 *
 * @generated from message bffuser.v1.DeleteBidTagResponse
 */
export type DeleteBidTagResponse = Message<"bffuser.v1.DeleteBidTagResponse"> & {
};

/**
 * Describes the message bffuser.v1.DeleteBidTagResponse.
 * Use `create(DeleteBidTagResponseSchema)` to create a new message.
 */
export const DeleteBidTagResponseSchema: GenMessage<DeleteBidTagResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_service, 21);

/**
 * BidLimitService aggregates Connect RPCs for the administrator "入札制限"
 * (bid-limits) screen. It manages the JEPX bid limit matrix, the per-area
 * market-order allow policy, the organization-wide block-mandatory toggle,
 * and the shared bid tags used on bid creation screens.
 *
 * Get RPCs are split per tab (= per bid_segment for matrix tabs,
 * ListBidTags for the tag tab) so each tab can cache / invalidate
 * independently. Update RPCs are operation-unit and map 1:1 to the
 * backend gRPC contract.
 *
 * @generated from service bffuser.v1.BidLimitService
 */
export const BidLimitService: GenService<{
  /**
   * GetBidLimitMatrixScreen returns all three matrix tabs' worth of
   * bid-limit state in one read (= AdminBidLimits screen aggregation).
   * Read-only BFF aggregation: fans out to backend
   * BidLimitService.GetBidLimitMatrix for SPOT_NORMAL, SPOT_BLOCK, INTRADAY.
   *
   * @generated from rpc bffuser.v1.BidLimitService.GetBidLimitMatrixScreen
   */
  getBidLimitMatrixScreen: {
    methodKind: "unary";
    input: typeof GetBidLimitMatrixScreenRequestSchema;
    output: typeof GetBidLimitMatrixScreenResponseSchema;
  },
  /**
   * GetBidLimitMatrix returns one tab's worth of bid-limit state for the
   * given bid_segment (cells + segment_meta, plus market_order_policy
   * for SPOT_NORMAL/INTRADAY or block_mandatory_policy for SPOT_BLOCK).
   *
   * @generated from rpc bffuser.v1.BidLimitService.GetBidLimitMatrix
   */
  getBidLimitMatrix: {
    methodKind: "unary";
    input: typeof GetBidLimitMatrixRequestSchema;
    output: typeof GetBidLimitMatrixResponseSchema;
  },
  /**
   * UpdateBidLimitMatrix replaces all cells of a single bid_segment
   * for the organization, using bid_limit_segment_meta.updated_at as
   * the optimistic-lock baseline.
   *
   * @generated from rpc bffuser.v1.BidLimitService.UpdateBidLimitMatrix
   */
  updateBidLimitMatrix: {
    methodKind: "unary";
    input: typeof UpdateBidLimitMatrixRequestSchema;
    output: typeof UpdateBidLimitMatrixResponseSchema;
  },
  /**
   * UpdateMarketOrderPolicy toggles the market-order allow flag for a
   * single (bid_segment, area_code) pair.
   *
   * @generated from rpc bffuser.v1.BidLimitService.UpdateMarketOrderPolicy
   */
  updateMarketOrderPolicy: {
    methodKind: "unary";
    input: typeof UpdateMarketOrderPolicyRequestSchema;
    output: typeof UpdateMarketOrderPolicyResponseSchema;
  },
  /**
   * UpdateBlockMandatoryPolicy toggles the organization-wide block-
   * mandatory flag.
   *
   * @generated from rpc bffuser.v1.BidLimitService.UpdateBlockMandatoryPolicy
   */
  updateBlockMandatoryPolicy: {
    methodKind: "unary";
    input: typeof UpdateBlockMandatoryPolicyRequestSchema;
    output: typeof UpdateBlockMandatoryPolicyResponseSchema;
  },
  /**
   * UpdateFeeAutoConsiderPolicy toggles the "手数料自動考慮" flag for a
   * single bid_segment (SPOT_NORMAL / INTRADAY, independent per segment).
   *
   * @generated from rpc bffuser.v1.BidLimitService.UpdateFeeAutoConsiderPolicy
   */
  updateFeeAutoConsiderPolicy: {
    methodKind: "unary";
    input: typeof UpdateFeeAutoConsiderPolicyRequestSchema;
    output: typeof UpdateFeeAutoConsiderPolicyResponseSchema;
  },
  /**
   * UpdateDefaultWithdrawOffset replaces the organization-wide default
   * withdraw offset for intraday bids (bidding/bid-limits.md §4,
   * AC-BDL-501/502/503).
   *
   * @generated from rpc bffuser.v1.BidLimitService.UpdateDefaultWithdrawOffset
   */
  updateDefaultWithdrawOffset: {
    methodKind: "unary";
    input: typeof UpdateDefaultWithdrawOffsetRequestSchema;
    output: typeof UpdateDefaultWithdrawOffsetResponseSchema;
  },
  /**
   * ListBidTags returns every bid tag for the organization.
   *
   * @generated from rpc bffuser.v1.BidLimitService.ListBidTags
   */
  listBidTags: {
    methodKind: "unary";
    input: typeof ListBidTagsRequestSchema;
    output: typeof ListBidTagsResponseSchema;
  },
  /**
   * CreateBidTag creates a new bid tag.
   *
   * @generated from rpc bffuser.v1.BidLimitService.CreateBidTag
   */
  createBidTag: {
    methodKind: "unary";
    input: typeof CreateBidTagRequestSchema;
    output: typeof CreateBidTagResponseSchema;
  },
  /**
   * UpdateBidTag performs a full replacement (PUT semantics) of the
   * bid tag. Uses optimistic locking via expected_updated_at.
   *
   * @generated from rpc bffuser.v1.BidLimitService.UpdateBidTag
   */
  updateBidTag: {
    methodKind: "unary";
    input: typeof UpdateBidTagRequestSchema;
    output: typeof UpdateBidTagResponseSchema;
  },
  /**
   * DeleteBidTag deletes the bid tag. Uses optimistic locking via
   * expected_updated_at.
   *
   * @generated from rpc bffuser.v1.BidLimitService.DeleteBidTag
   */
  deleteBidTag: {
    methodKind: "unary";
    input: typeof DeleteBidTagRequestSchema;
    output: typeof DeleteBidTagResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_bid_limit_service, 0);

